module.exports = __webpack_public_path__ + "img/emoji-smile-upside-down-fill.379d4734.svg";